import script from "./MapHotspot.vue?vue&type=script&lang=ts&setup=true"
export * from "./MapHotspot.vue?vue&type=script&lang=ts&setup=true"

import "./MapHotspot.vue?vue&type=style&index=0&id=fe9bf96e&lang=stylus&scoped=true"

import exportComponent from "/codebuild/output/src024011243/src/2022-meta-acrossthemetaverse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fe9bf96e"]])

export default __exports__